import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const VIDEO_ID = '2JncwzdDDno';
const APPLY_URL = 'https://forms.gle/6Y4JwzMB8iZJqQuKA';

const Join = () => {
  return (
    <div>
      <Header />
      <main>
        {/* Full-screen video banner above the fold */}
        <section style={{ width: '100%', height: 'calc(100vh - 190px)', minHeight: 420 }}>
          <iframe
            src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${VIDEO_ID}&rel=0`}
            title="Join NEXT video"
            style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </section>

        {/* Text content below the video */}
        <section style={{ padding: '4rem 2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ maxWidth: 860, width: '100%', fontFamily: "'Barlow', sans-serif", fontWeight: 'normal', fontSize: '25.8px', lineHeight: '31px', color: '#FFFFFF' }}>
            {/* Header 1 — same as the Services page heading */}
            <h1
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontWeight: 400,
                fontSize: '41px',
                letterSpacing: '0.05em',
                color: '#FFFFFF',
                margin: 0,
              }}
            >
              Your NEXT Opportunity Starts Here. Apply Today.
            </h1>
            {/* Header 2 — Services yellow category style */}
            <p
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontWeight: 400,
                fontSize: '32px',
                letterSpacing: '0.05em',
                lineHeight: 1.3,
                color: '#F9DE4B',
                marginTop: '2rem',
              }}
            >
              NEXT Student Agency brings together ambitious Humber Polytechnic learners to collaborate
              on real projects, for real clients. You'll strengthen your craft, build your portfolio,
              expand your network and gain the experience you need to stand out from your peers.
            </p>
            <p style={{ marginTop: '1.5rem', marginBottom: 0 }}>
              You are eligible to apply if:
            </p>
            <ol style={{ marginTop: '0.75rem', paddingLeft: '2rem' }}>
              <li>
                You are currently enrolled at Humber Polytechnic and are either;
                <ul style={{ listStyle: 'none', paddingLeft: '1rem', margin: '0.25rem 0' }}>
                  <li>- In your second year or above; or</li>
                  <li>- Enrolled in a one year graduate certificate program</li>
                </ul>
              </li>
              <li>You are pursuing a career in marketing, creative, communications or business</li>
              <li>You are curious, collaborative and determined to grow and ready to make the most of the opportunity.</li>
            </ol>
            <p style={{ marginTop: '1.5rem' }}>
              Ready for the NEXT step?
            </p>
            <div style={{ textAlign: 'center', margin: '2rem 0' }}>
              <a
                href={APPLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#F9DE4B',
                  color: '#000000',
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: '1.8rem',
                  letterSpacing: '0.08em',
                  padding: '0.75rem 3rem',
                  textDecoration: 'none',
                }}
              >
                APPLY NOW
              </a>
            </div>
            <p>
              <a
                href={APPLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#F9DE4B', textDecoration: 'underline' }}
              >
                If you are interested you can click here to apply.
              </a>{' '}
              Applications close October 1st.
            </p>
            <p style={{ marginTop: '1.5rem' }}>
              All applicants are invited to attend an information session on October 1st at 6pm at
              Humber Polytechnic's Lakeshore Campus, F Building, Room F116.
            </p>
            <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              We can't wait to meet you on the 1st!
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Join;
